import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"

const Footer = () => {
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <div className="main-footer">
      <div className="main-footer__inner">
        <div className="main-footer__inner__left">
          <div>
            <Link to="/">
              <img
                style={{ cursor: "pointer" }}
                width={"250px"}
                height={"50px"}
                src={
                  "https://alignerbase-public.s3.us-east-2.amazonaws.com/alignerbase-web-nav-logo.png"
                }
                alt="header logo"
              />
              <div className="main-footer__inner__left__tagline">
                Empowering Practitioners, Advancing Orthodontics.
              </div>
            </Link>
            <div class="main-footer__social-media">
              <div>Follow us on</div>
              <a href="https://www.linkedin.com/company/alignerbase/">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  data-supported-dps="24x24"
                  fill="#0a66c2"
                  class="mercado-match"
                  width="34"
                  height="34"
                  focusable="false"
                >
                  <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z"></path>
                </svg>
              </a>
            </div>
          </div>

          <div>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/services">Services</Link>
              </li>
              <li>
                <Link to="/plan-and-pricing">Plans and Pricing</Link>
              </li>
              <li>
                <Link to="/about-us">About</Link>
              </li>
              <li>
                <Link to="/careers">Careers</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact Us</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="main-footer__inner__right gap-8">
          <div className="mt-4">
            <h4>Contact Us</h4>
            <Link to={"/contact-us"}>
              <div
                className="main-footer__inner__btn"
                style={{
                  textAlign: "center",
                  borderRadius: "10px",
                  backgroundColor: "#43accc",
                  color: "#fff",
                  padding: "0.5rem 1.5rem",
                }}
              >
                Contact Us
              </div>
            </Link>
            <div className="text-center py-2">or</div>

            <p className="text-center">
              Email:{" "}
              <a href="mailto:info@alignerbase.com">info@alignerbase.com</a>
            </p>
          </div>
          <div className="mt-4">
            <h4>Write to Us</h4>
            <p>
              AlignerBase LLC <br />
              1007 N Orange St <br />
              4th Floor Suite 1357 <br />
              Wilmington, DE 19801 <br />
              United States
            </p>
          </div>
        </div>
      </div>

      <div className="main-footer__below py-4 md:flex items-center md:justify-between">
        <div className="mb-2 md:mb-0">
          Copyright © 2023, {data.site.siteMetadata.title} LLC. All Rights
          Reserved.
        </div>
        <div className="flex gap-5 justify-center">
          <div>
            <Link to="/business-associate-agreement">
              HIPAA Business Associate Agreement
            </Link>
          </div>
          <div>
            <Link to="/terms-of-service">Terms of Service</Link>
          </div>
          <div>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
